const entityName = 'users';

const userModule = {
  state: {},
  mutations: {},
  actions: {
    fetchAll: (context) => {
      const url = entityName;
      return context.dispatch('getAllEntity', {url, entityName})
    },
    postUser: (context, user) => {
      const payload = {
        url: entityName,
        entityName: entityName,
        entity: user
      };
      return context.dispatch('postEntity', payload)
    },
    updateUser: (context, user) => {
      const payload = {
        url: entityName + '/' + user._id,
        entityName: entityName,
        entity: user
      };
      return context.dispatch('putEntity', payload)
    },
    removeUser: (context, user) => {
      const payload = {
        url: entityName + '/' + user._id,
        entityName: entityName,
        entity: user
      };
      return context.dispatch('deleteEntity', payload)
    },
  },
  getters: {}
};

export default userModule;
